import _ from 'lodash';
import querystring from 'qs';
import { Component } from 'react';
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import { getBadgeData } from './ContractorBadges';
import FACResults from './Results';
import { FACSidebar } from './Sidebar';
import inferUnits from './inferUnits';
import responseTransform from './responseTransform';
import { FindAContractorConnector } from '../../redux/connectors/FindAContractorConnector';
import { ContractorBadgeModal } from '../CertificationsModal';
import { connectLocation } from '../location/LocationConnectors';

const Disclaimer = connectLocation(({ t }) => (
  <p className="footnote disclaimer-bottom" dangerouslySetInnerHTML={{ __html: t('contractors.disclaimer') }} />
));

class XFAC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: null,
      badgeData: null,
      isMobileOnly: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    getBadgeData(this.props.locale.code).then(badgeData => {
      this.setState({ badgeData });
    });
    this.setState({
      isMobileOnly: window.matchMedia('(hover: none) and (pointer: coarse)').matches,
    });
  }

  componentDidUpdate(prevProps) {
    const distanceChanged = prevProps.maxDistance !== this.props.maxDistance && !this.props.autoExpandedRange;
    const sortChanged = prevProps.sortBy !== this.props.sortBy;
    if (distanceChanged || sortChanged) {
      this.load();
    }
  }

  openModal(modalHash) {
    this.setState({
      modalOpen: modalHash,
    });
  }

  closeModal() {
    this.setState({
      modalOpen: null,
    });
  }

  fetchContractorLocations() {
    const { city, region, latitude: lat, longitude: lng } = this.props.address;
    const { maxDistance: radius, sortBy: sort, locale } = this.props;
    const params = {
      lat,
      lng,
      radius,
      units: inferUnits(locale),
      sort,
      per_page: 10000,
      c_code: this.props.locale.code,
    };

    const toolseyRaqEnabled = locale.countryName === 'United States';

    const query = querystring.stringify(params);
    return fetch(`${MDMS_URL}/api/v3/locations/roofing-contractors?${query}`)
      .then(response => response.json())
      .then(response =>
        responseTransform({
          response,
          radius,
          city,
          region,
          toolseyRaqEnabled,
        })
      );
  }

  load() {
    const { updateAPI } = this.props;
    this.fetchContractorLocations().then(updateAPI);
  }

  render() {
    const openedBadgeModal = _.isPlainObject(this.state.modalOpen)
      ? this.state.modalOpen
      : (this.state.badgeData || []).filter(badge => badge.value == this.state.modalOpen)[0];

    return (
      <>
        <div className="columns ratio-1-3 tablet-stack">
          <div className="col">
            <FACSidebar
              badgeData={this.state.badgeData}
              bot={!!this.props.bot}
              openModal={this.openModal}
              isMobileOnly={this.state.isMobileOnly}
            />
          </div>
          <div className="col">
            <FACResults badgeData={this.state.badgeData} bot={!!this.props.bot} openModal={this.openModal} />
          </div>

          {openedBadgeModal && (
            <ContractorBadgeModal open details={openedBadgeModal.details} onClose={this.closeModal} />
          )}
        </div>
        <Disclaimer />
      </>
    );
  }
}

const FAC = FindAContractorConnector(connectLocation(XFAC));

export default props => (
  <Provider store={ReactOnRails.getStore('Store')}>
    <FAC {...props} />
  </Provider>
);
